<template>
    <div>
        <div class="accordion-item js-preloader" >
            <div class="header-artist-accordion row align-items-center">
                 <div class="col-12 col-sm-6 col-md-4 col-xl-3">
                    <p class="big-artist-text mb-0 start-date">{{ bid.start_date }}</p>
                    <p class="main-text">Start Date</p>
                </div>

                <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                    <p class="big-artist-text mb-0 budget-bid">${{ bid.budget }}</p>
                    <p class="main-text">Payout</p>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-3 word-break mr-4">
                    <div class="d-flex flex-wrap wrapper-keywords-pills">
                        <div class="keywords-pills mb-2" v-for="(keyword, index) in bid.array_keywords"
                            :key="index">{{ keyword }}
                        </div>
                    </div>
                    <p class="main-text text-muted mt-2 mb-0">Sound</p>
                </div>
                <div class="col-12 col-sm-6 col-md-4 col-xl-2">
                    <p class="big-artist-text mb-1 city-address">{{ bid.city_with_state_address }}</p>
                    <p class="main-text text-muted">Location</p>
                </div>
                <div class="col-12 col-md-7 col-xl-2 d-flex justify-content-start justify-content-xl-center">
                    <button class="btn-apply button-text" type="button"
                            data-bs-toggle="collapse" @click="resetExtraInfoBid()"
                            :data-bs-target="'#search-flush-collapse' + bid.id">
                        {{ showAccordion ? 'Hide Info' : 'See More' }}
                    </button>
                </div>
            </div>

            <div :id="'search-flush-collapse' + bid.id" class="accordion-collapse collapse"
                data-bs-parent="#search-accordion-flash" aria-expanded="false">
                <div class="accordion-body">
                    <div class="row mb-4">
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                            <p class="main-text-bold">Sound Equipment</p>
                            <p class="main-text">
                                <span v-if="bid.bring_equipment">Artist must bring own sound equipment</span>
                                <span v-else>Artist mustn't bring own sound equipment</span>
                            </p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-8 mt-4">
                            <p class="main-text-bold">Special Riders/Extras</p>
                            <p class="main-text">{{ bid.riders ? bid.riders : '-' }}</p>
                        </div>

                    </div>
                    <div class="row mb-4">
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                            <p class="big-artist-text mb-1">{{ bid.start_time }}</p>
                            <p class="main-text">Start Time</p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                            <p class="big-artist-text mb-1">{{ bid.duration }} hr</p>
                            <p class="main-text">Duration</p>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 mt-4">
                            <p class="big-artist-text mb-1">{{ bid.venue.venue_info.capacity }}</p>
                            <p class="main-text">Venue Capacity</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-md-6 col-4">
                            <label for="budget" class="main-text-bold pb-3 pt-3 px-0">Include counter
                                offer</label>
                            <div class="form-input-border input-group border-50">
                                <div class="col-2 d-flex justify-content-center align-items-center">
                                    <span class="main-text-bold">$</span>
                                </div>
                                <div class="col-10">
                                    <div class="custom-number-input-wrapper">
                                        <input type="text" v-model="extraInfoBid.bid_id" hidden
                                            name="bid_id"
                                        >
                                        <input v-model="extraInfoBid.counter_offer"
                                            placeholder="Counter offer" type="number" id="counter_offer"
                                            min="0" max="10000"
                                            name="counter_offer"
                                            class="w-100 custom-arrows budget group-input border-50 py-4">
                                        </div>
                                    </div>
                                </div>
                                <span class="invalid-feedback" role="alert"><strong></strong></span>
                            </div>
                            <div class="col-12 col-md-6 col-4">
                                <label for="riders" class="main-text-bold pb-3 pt-3 px-0">Extra
                                    Requirements</label>
                                <textarea v-model="extraInfoBid.extra_requirements" name="extra_requirements"
                                    id="riders"
                                    class="bid-textarea form-control profile-textarea js-auto-height"
                                    placeholder="Extra Requirements"
                                    rows="4"></textarea>
                            </div>
                        </div>
                        <div class="row justify-content-end cancel mt-4">
                            <div class="col-5 text-end">
                                <button class="btn-apply button-text" @click="applyBid(bid, $event)"
                                        type="button">
                                    Apply
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
</template>

<script>
export default {
    name: 'AccordionItemBids',
    props: {
        bid: {
            type: Object
        }
    },
    data: () => ({
        showAccordion: false,
        extraInfoBid: {
            counter_offer: null,
            extra_requirements: null,
        }
    }),
    methods: {
        resetExtraInfoBid() {
            this.showAccordion = !this.showAccordion
            this.extraInfoBid = {
                counter_offer: null,
                extra_requirements: null,
            }
        },
        applyBid(bid, event) {
            $('#auth-modal-guest').modal('show')
            localStorage.setItem('bidId', bid.id)
            localStorage.setItem('data', JSON.stringify(this.extraInfoBid))
            this.$emit('applyEvent', bid, event)
        }
    }
}
</script>
